import CookieConsent from "react-cookie-consent";
import { CONSENT_COOKIE_NAME, grantAnalyticsConsent } from "../services/cookieConsent";

export const CookieConsentBanner = () => (
  <CookieConsent
    location="bottom"
    cookieName={CONSENT_COOKIE_NAME}
    buttonText="Accetta"
    declineButtonText="Rifiuta"
    enableDeclineButton
    disableButtonStyles
    buttonClasses="bg-indigo-600 hover:bg-indigo-700 text-white text-[13px] font-semibold px-5 py-2.5 rounded-md"
    declineButtonClasses="bg-gray-700 hover:bg-gray-800 text-white text-[13px] font-semibold px-5 py-2.5 rounded-md"
    buttonWrapperClasses="flex flex-wrap gap-3 items-center px-4 pb-4 sm:pb-0"
    onAccept={() => grantAnalyticsConsent()}
    onDecline={() => {}}
    style={{ background: "#2B373B" }}
  >
    Questo sito utilizza cookie tecnici necessari al funzionamento e, previo tuo
    consenso, cookie di analisi e marketing. Cliccando su &quot;Accetta&quot;
    acconsenti all'uso di tutti i cookie; cliccando su &quot;Rifiuta&quot;
    continuerai la navigazione con i soli cookie tecnici. Per maggiori
    informazioni consulta la{" "}
    <a
      href="/cookie-policy"
      className="text-blue-500 hover:text-blue-700 font-semibold underline hover:underline"
    >
      Cookie Policy.
    </a>
  </CookieConsent>
);
